<main class="container my-4" *ngIf="viewScreen === ''">
  <form [formGroup]="searchForm" (submit)="search()">
    <div class="card-wrap">
      <div class="d-flex wrap-history">
        <button
          class="btn bulk-search"
          type="button"
          (click)="showBulkSearch()"
        >
          <i class="bi bi-search icon fs-4 btn-icon"></i
          >{{ constants.SEARCH_PROFILE.BULK_SEARCH_BUTTON }}
        </button>
        <button class="btn history-btn" type="button" (click)="goToHistory()">
          <i class="bi bi-clock-history icon fs-4 btn-icon"></i
          >{{ constants.SEARCH_PROFILE.VIEW_SEARCH_HISTORY }}
        </button>
      </div>
      <div class="d-flex sc-head">
        <h6 class="sc-title">{{ constants.SEARCH_PROFILE.SEARCH_CUSTOMER }}</h6>
        <div class="select-type">
          <label for="type" class="form-label"
            >{{ constants.SEARCH_PROFILE.TYPE }}
          </label>
          <select
            class="form-control form-control-sm mw60"
            formControlName="type"
            (change)="onTypeChange()"
          >
            <!-- <option value="">-- Select Type --</option> -->
            <option value="{{ type.type }}" *ngFor="let type of types">
              {{ type.type }}
            </option>
          </select>
        </div>
      </div>

      <!-- Demographics Section -->
      <div class="card card-custom">
        <div class="section-title">
          {{ constants.SEARCH_PROFILE.DEMOGRAPICS }}
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="name" class="form-label">{{
                constants.SEARCH_PROFILE.NAME
              }}</label>
              <input
                matInput
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter Name"
                [maxlength]="50"
                [minlength]="2"
                formControlName="name"
              />
              <mat-error
                class="error-msg"
                *ngIf="searchForm.get('name')?.hasError('minlength')"
              >
                Please enter at least 2 characters.
              </mat-error>

              <div
                *ngIf="
                  !searchForm.get('name')?.valid &&
                  (searchForm.get('name')?.touched ||
                    searchForm.get('name')?.dirty)
                "
              >
                <mat-error
                  class="error-msg"
                  *ngIf="checkError('name', 'pattern')"
                >
                  {{ constants.SEARCH_PROFILE.VALID_NAME_ERROR }}
                </mat-error>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="address" class="form-label lbladdress"
                >{{ constants.SEARCH_PROFILE.ADDRESS }}
                <mat-icon
                  matTooltip="Address format should be like '4327 N Ash St Apt B115, Spokane, WA 99205' etc."
                  style="margin-top: 1px"
                  aria-label="Button that displays a tooltip when focused or hovered over"
                  aria-hidden="true"
                >
                  info
                </mat-icon></label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter Address"
                [maxlength]="50"
                [minlength]="2"
                formControlName="address"
                #address
                (blur)="onBlur(address.value)"
              />

              <mat-error
                class="error-msg"
                *ngIf="searchForm.get('address')?.hasError('minlength')"
              >
                Please enter at least 2 characters.
              </mat-error>
              <div
                *ngIf="
                  !searchForm.get('address')?.valid &&
                  (searchForm.get('address')?.touched ||
                    searchForm.get('address')?.dirty)
                "
              >
                <mat-error
                  class="error-msg"
                  *ngIf="checkError('address', 'pattern')"
                >
                  {{ constants.SEARCH_PROFILE.VALID_ADDRESS_ERROR }}
                </mat-error>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="city" class="form-label">{{
                constants.SEARCH_PROFILE.CITY
              }}</label>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter City"
                [maxlength]="30"
                [minlength]="2"
                formControlName="city"
              />
              <mat-error
                class="error-msg"
                *ngIf="searchForm.get('city')?.hasError('minlength')"
              >
                Please enter at least 2 characters.
              </mat-error>
              <div
                *ngIf="
                  !searchForm.get('city')?.valid &&
                  (searchForm.get('city')?.touched ||
                    searchForm.get('city')?.dirty)
                "
              >
                <mat-error
                  class="error-msg"
                  *ngIf="checkError('city', 'pattern')"
                >
                  {{ constants.SEARCH_PROFILE.VALID_CITY_ERROR }}
                </mat-error>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label for="state" class="form-label">{{
                constants.SEARCH_PROFILE.STATE
              }}</label>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter State"
                [maxlength]="30"
                [minlength]="2"
                formControlName="state"
              />
              <mat-error
                class="error-msg"
                *ngIf="searchForm.get('state')?.hasError('minlength')"
              >
                Please enter at least 2 characters.
              </mat-error>
              <div
                *ngIf="
                  !searchForm.get('state')?.valid &&
                  (searchForm.get('state')?.touched ||
                    searchForm.get('state')?.dirty)
                "
              >
                <mat-error
                  class="error-msg"
                  *ngIf="checkError('state', 'pattern')"
                >
                  {{ constants.SEARCH_PROFILE.VALID_STATE_ERROR }}
                </mat-error>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <label for="zip" class="form-label">{{
                constants.SEARCH_PROFILE.ZIP
              }}</label>
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter ZIP"
                [maxlength]="10"
                formControlName="zip"
              />
              <div
                *ngIf="
                  !searchForm.get('zip')?.valid &&
                  (searchForm.get('zip')?.touched ||
                    searchForm.get('zip')?.dirty)
                "
              >
                <mat-error
                  class="error-msg"
                  *ngIf="checkError('zip', 'pattern')"
                >
                  {{ constants.SEARCH_PROFILE.VALID_ZIP_ERROR }}
                </mat-error>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Identifiers Section -->
      <div class="row">
        <div class="col-md-6">
          <div class="card card-custom card-mb0">
            <div class="section-title">
              {{ constants.SEARCH_PROFILE.INTERNAL_IDENTIFIERS }}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 mb-3">
                  <label for="rcm_id" class="form-label">
                    {{ constants.SEARCH_PROFILE.RCM_ID }}
                  </label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter RCM ID"
                    formControlName="rcm_id"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('rcm_id')?.valid &&
                      (searchForm.get('rcm_id')?.touched ||
                        searchForm.get('rcm_id')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('rcm_id')?.hasError('minlength') &&
                          !searchForm.get('rcm_id')?.hasError('pattern')
                        "
                      >
                        Please enter at least 10 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('rcm_id')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_RCM_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>

                <div class="col-md-3 mb-3">
                  <label for="ishift" class="form-label">SHIFT MDG ID</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter SHIFT ID"
                    formControlName="ishift"
                  />
                </div>

                <div class="col-md-3 mb-3">
                  <label for="rmus" class="form-label">RMUS TP ID</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter RMUS ID"
                    formControlName="rmus"
                  />
                </div>

                <div class="col-md-3 mb-3">
                  <label for="crm" class="form-label">Legacy SAP CRM ID </label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter CRM ID"
                    formControlName="crm"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label for="source" class="form-label">{{
                    constants.SEARCH_PROFILE.SOURCE
                  }}</label>
                  <select
                    class="form-control form-control-sm"
                    formControlName="source"
                    (change)="onChangeSource()"
                  >
                    <option value="">
                      {{ constants.SEARCH_PROFILE.NOT_SELECTED }}
                    </option>
                    <option
                      value="{{ source.source }}"
                      *ngFor="let source of sourceList"
                    >
                      {{ source.source }}
                    </option>
                  </select>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="source_id" class="form-label">{{
                    constants.SEARCH_PROFILE.SOURCE_ID
                  }}</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter Source ID"
                    [maxlength]="30"
                    [readOnly]="this.searchForm.get('source')!.value === ''"
                    [ngClass]="
                      this.searchForm.get('source')!.value === '' ||
                      isSearchFormValid
                        ? ''
                        : 'redBorder'
                    "
                    formControlName="source_id"
                  />
                  <mat-error
                    class="error-msg"
                    *ngIf="
                      this.searchForm.get('source')!.value === '' &&
                      searchForm.get('source_id')?.touched &&
                      displaySourceError
                    "
                  >
                    {{ constants.SEARCH_PROFILE.SOURCE_REQUIRED }}
                  </mat-error>

                  <mat-error
                    class="error-msg"
                    *ngIf="
                      this.searchForm.get('source')!.value !== '' &&
                      this.searchForm.get('source_id')!.value === ''
                    "
                  >
                    {{ constants.SEARCH_PROFILE.VALID_SOURCE_ID_ERROR }}
                  </mat-error>

                  <div
                    *ngIf="
                      !searchForm.get('source_id')?.valid &&
                      (searchForm.get('source_id')?.touched ||
                        searchForm.get('source_id')?.dirty)
                    "
                  >
                    <mat-error
                      class="error-msg"
                      *ngIf="checkError('source_id', 'pattern')"
                    >
                      {{ constants.SEARCH_PROFILE.VALID_SOURCE_ID_ERROR }}
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card card-custom card-mb0">
            <div class="section-title">
              {{ constants.SEARCH_PROFILE.EXTERNAL_IDENTIFIERS }}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 mb-3">
                  <div class="label-img">
                    <label
                      for="DEA"
                      for="exampleFormControlInput"
                      class="form-label lblcaption"
                      >{{ constants.SEARCH_PROFILE.DEA }}</label
                    >
                    <img alt="dea image" src="assets/images/dea.png" />
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter DEA"
                    [maxlength]="9"
                    [minlength]="7"
                    formControlName="dea"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('dea')?.valid &&
                      (searchForm.get('dea')?.touched ||
                        searchForm.get('dea')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('dea')?.hasError('minlength') &&
                          !searchForm.get('dea')?.hasError('pattern')
                        "
                      >
                        Please enter at least 7 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('dea')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_DEA_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <div class="label-img">
                    <label
                      for="HIN"
                      for="exampleFormControlInput"
                      class="form-label lblcaption"
                      >{{ constants.SEARCH_PROFILE.HIN }}</label
                    >
                    <img alt="hin image" src="assets/images/hibcc.png" />
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter HIN"
                    [maxlength]="9"
                    [minlength]="2"
                    formControlName="hin_no"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('hin_no')?.valid &&
                      (searchForm.get('hin_no')?.touched ||
                        searchForm.get('hin_no')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('hin_no')?.hasError('minlength') &&
                          !searchForm.get('hin_no')?.hasError('pattern')
                        "
                      >
                        Please enter at least 2 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('hin_no')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_HIN_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <div class="label-img">
                    <label
                      for="340B"
                      for="exampleFormControlInput"
                      class="form-label lblcaption"
                      >{{ constants.SEARCH_PROFILE.EI_340B }}</label
                    >
                    <img alt="340b image" src="assets/images/hrsa.jfif" />
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter 340B"
                    [maxlength]="11"
                    [minlength]="2"
                    formControlName="id_340b"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('id_340b')?.valid &&
                      (searchForm.get('id_340b')?.touched ||
                        searchForm.get('id_340b')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('id_340b')?.hasError('minlength') &&
                          !searchForm.get('id_340b')?.hasError('pattern')
                        "
                      >
                        Please enter at least 2 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('id_340b')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_EI_340B_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <div class="label-img">
                    <label
                      for="NPI"
                      for="exampleFormControlInput"
                      class="form-label lblcaption"
                      >{{ constants.SEARCH_PROFILE.NPI }}</label
                    >
                    <img alt="npi image" src="assets/images/npi.png" />
                  </div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter NPI"
                    [maxlength]="10"
                    [minlength]="10"
                    formControlName="npi"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('npi')?.valid &&
                      (searchForm.get('npi')?.touched ||
                        searchForm.get('npi')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('npi')?.hasError('minlength') &&
                          !searchForm.get('npi')?.hasError('pattern')
                        "
                      >
                        Please enter at least 10 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('npi')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_NPI_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="SLN" class="form-label">{{
                    constants.SEARCH_PROFILE.SLN
                  }}</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter SLN"
                    [maxlength]="50"
                    [minlength]="2"
                    formControlName="sln"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('sln')?.valid &&
                      (searchForm.get('sln')?.touched ||
                        searchForm.get('sln')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('sln')?.hasError('minlength') &&
                          !searchForm.get('sln')?.hasError('pattern')
                        "
                      >
                        Please enter at least 2 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('sln')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_SLN_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="TDDD" class="form-label">{{
                    constants.SEARCH_PROFILE.TDDD
                  }}</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter TDDD"
                    [maxlength]="50"
                    formControlName="tddd"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('tddd')?.valid &&
                      (searchForm.get('tddd')?.touched ||
                        searchForm.get('tddd')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('tddd')?.hasError('minlength') &&
                          !searchForm.get('tddd')?.hasError('pattern')
                        "
                      >
                        Please enter at least 2 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('tddd')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_TDDD_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="HCCE" class="form-label">{{
                    constants.SEARCH_PROFILE.HCCE
                  }}</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter HCCE"
                    [maxlength]="50"
                    formControlName="hcce"
                  />
                  <div
                    *ngIf="
                      !searchForm.get('hcce')?.valid &&
                      (searchForm.get('hcce')?.touched ||
                        searchForm.get('hcce')?.dirty)
                    "
                  >
                    <mat-error class="error-msg">
                      <ng-container
                        *ngIf="
                          searchForm.get('hcce')?.hasError('minlength') &&
                          !searchForm.get('hcce')?.hasError('pattern')
                        "
                      >
                        Please enter at least 2 characters.
                      </ng-container>
                      <ng-container
                        *ngIf="searchForm.get('hcce')?.hasError('pattern')"
                      >
                        {{ constants.SEARCH_PROFILE.VALID_HCCE_ERROR }}
                      </ng-container>
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row btn-row">
        <div class="col-12">
          <div class="buttons">
            <button class="btn reset-btn" type="button" (click)="onReset()">
              Reset
            </button>
            <button
              class="btn search-btn"
              [disabled]="!searchForm.valid || !isSearchFormValid"
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</main>
<app-loader *ngIf="showLoader()"></app-loader>
<app-result-profile
  *ngIf="viewScreen === 'Result'"
  [goldenProfiles]="goldenProfiles"
  [sourceCrossReferences]="sourceCrossReferences"
  [searchParams]="searchParams"
  [columnModal]="columnModal"
  [colPref]="colPref"
  [sourceList]="sourceList"
>
</app-result-profile>
<app-search-history *ngIf="viewScreen === 'History'"></app-search-history>
